import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DropdownHeader from './DropdownHeader';
import AppsList from './AppsList';

const AppList = ({ data }) => (
  <Fragment>
    <div className="d-flex align-items-center pl-xs header" >
      <DropdownHeader headerName="Stores" />
    </div>
    <AppsList data={data} />
  </Fragment>
);

AppList.propTypes = {
  data: PropTypes.array.isRequired,
};

export default AppList;
